import { render, staticRenderFns } from "./ListPagamento.vue?vue&type=template&id=1dfc936f"
import script from "./ListPagamento.vue?vue&type=script&lang=js"
export * from "./ListPagamento.vue?vue&type=script&lang=js"
import style0 from "./ListPagamento.vue?vue&type=style&index=0&id=1dfc936f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports